import script from "./Page12.vue?vue&type=script&setup=true&lang=js"
export * from "./Page12.vue?vue&type=script&setup=true&lang=js"

import "./Page12.vue?vue&type=style&index=0&id=4455ef85&lang=less"

const __exports__ = script;

export default __exports__